import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const PERFORMER_DETAILS_URL =
  `${BASE_URL}/rest/v1.0/search/performer/{performerName}`;

export const PERFORMER_HOURS_URL =
  `${BASE_URL}/rest/v1.0/broadcasts/{username}?startTime={startTime}&endTime={endTime}`;

export const PERFORMER_PRIVATE_SHOW_REVENUE_URL =
  `${BASE_URL}/rest/v2.0/private-shows/{username}?from={from}&to={to}`;

export const PERFORMER_REVENUE_INSIGHTS =
  `${BASE_URL}/rest/v1.0/reporting/user/{performerName}/insights?from={startDate}&to={endDate}`;
